
/** Account objects returned from Quickbooks */
export interface IntuitAccount {
  Id: string;
  Name: string;
  Classification: string;
  AccountType: string;
  AccountSubType: string;
}

/** Item objects returned from Quickbooks */
export interface IntuitItem {
  Id: string;
  Name: string;
  Type: string;
  IncomeAccountRef: { name: string, Value: string };
}

export interface AccountsAndItems {
  accounts: IntuitAccount[];
  items: IntuitItem[];
}

export enum IntuitAccountTypeEnum
{
  Bank,
  AccountsReceivable,
  OtherCurrentAsset,
  FixedAsset,
  OtherAsset,
  AccountsPayable,
  CreditCard,
  OtherCurrentLiability,
  LongTermLiability,
  Equity,
  Income,
  CostofGoodsSold,
  Expense,
  OtherIncome,
  OtherExpense,
  NonPosting
}

export enum IntuitItemTypeEnum
{
  Assembly,
  Category,
  FixedAsset,
  Group,
  Inventory,
  NonInventory,
  OtherCharge,
  Payment,
  Service,
  Subtotal,
  Discount,
  Tax,
  TaxGroup,
  Bundle
}


export enum MonthEnum {
  January = 1,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December
}

/**
 * Placeholder — replace with your concrete definition if you already have one.
 */
export interface PhysicalAddress {
  Line1?: string;
  Line2?: string;
  City?: string;
  CountrySubDivisionCode?: string;
  PostalCode?: string;
  Country?: string;
}

/** Placeholder for email address object */
export interface EmailAddress {
  Address?: string;
  Tag?: string;
}

/** Placeholder for website address object */
export interface WebSiteAddress {
  Url?: string;
  Tag?: string;
}

/** Placeholder for telephone number */
export interface TelephoneNumber {
  Number?: string;
  CountryCode?: string;
  Tag?: string;
}

/** Placeholder for contact info */
export interface ContactInfo {
  ContactName?: string;
  ContactValue?: string;
  Type?: string;
}

/** Name/value pair for additional preferences */
export interface NameValue {
  Name?: string;
  Value?: string;
}

/**
 * Placeholder enum for fifo calculation status.
 * Replace values with real ones from your C# enum if available.
 */
export enum FifoCalculationStatus {
  Unknown = 0,
  NotCalculated = 1,
  Calculated = 2
}

/** Generic extension holder */
export interface IntuitAnyType {
  [key: string]: any;
}

export interface CompanyInfo {
  // Product: ALL Description: Name of the company.
  CompanyName?: string;

  // LegalName if different from the CompanyName
  LegalName?: string;

  // Company Address as described in preference
  CompanyAddr?: PhysicalAddress;

  // Address of the company as given to the customer
  CustomerCommunicationAddr?: PhysicalAddress;

  // Legal Address given to the government for any government communication
  LegalAddr?: PhysicalAddress;

  // CompanyEmail Address
  CompanyEmailAddr?: EmailAddress;

  // Email Address published to customer for communication if different from CompanyEmailAddress
  CustomerCommunicationEmailAddr?: EmailAddress;

  // Company URL
  CompanyURL?: WebSiteAddress;

  // Primary Phone number
  PrimaryPhone?: TelephoneNumber;

  // List of ContactInfo entities
  OtherContactInfo?: ContactInfo[];

  // QuickBooks company file name
  CompanyFileName?: string;

  // QB software flavor being used on the file on the PC
  FlavorStratum?: string;

  // if the QB desktop file is a sample file.
  SampleFile?: boolean;

  // Specified flag for SampleFile (kept as part of API surface)
  SampleFileSpecified?: boolean;

  // IAM or QBN admin users id sequence number
  CompanyUserId?: string;

  // IAM or QBN admin users email
  CompanyUserAdminEmail?: string;

  // DateTime when the company file was created.
  CompanyStartDate?: Date | string;

  // Specified flag for CompanyStartDate
  CompanyStartDateSpecified?: boolean;

  // Employer identifier (EID).
  EmployerId?: string;

  // Starting month of the company's fiscal year.
  FiscalYearStartMonth?: MonthEnum;

  // Specified flag for FiscalYearStartMonth
  FiscalYearStartMonthSpecified?: boolean;

  // Starting month of the company's tax year.
  TaxYearStartMonth?: MonthEnum;

  // Specified flag for TaxYearStartMonth
  TaxYearStartMonthSpecified?: boolean;

  // QuickBooks company file latest version.
  QBVersion?: string;

  // Country name to which the company belongs for financial calculations.
  Country?: string;

  // Default shipping address.
  ShipAddr?: PhysicalAddress;

  // Other company addresses.
  OtherAddr?: PhysicalAddress[];

  // Default mobile phone number of the company.
  Mobile?: TelephoneNumber;

  // Default fax number.
  Fax?: TelephoneNumber;

  // Default email address.
  Email?: EmailAddress;

  // Default company web site address.
  WebAddr?: WebSiteAddress;

  // Specifies last imported time.
  LastImportedTime?: Date | string;

  // Specified flag for LastImportedTime
  LastImportedTimeSpecified?: boolean;

  // Specifies last sync time.
  LastSyncTime?: Date | string;

  // Specified flag for LastSyncTime
  LastSyncTimeSpecified?: boolean;

  // Comma separated list of languages
  SupportedLanguages?: string;

  // Default time zone for the company
  DefaultTimeZone?: string;

  // Specifies if the company supports multibyte or not
  MultiByteCharsSupported?: boolean;

  // Specified flag for MultiByteCharsSupported
  MultiByteCharsSupportedSpecified?: boolean;

  // Any other preference not covered in base is covered as name value pair
  NameValue?: NameValue[];

  // Status of the Inventory Lots and Accounts Calculation for STQ imported company.
  FifoCalculationStatus?: FifoCalculationStatus;

  // Specified flag for FifoCalculationStatus
  FifoCalculationStatusSpecified?: boolean;

  // Internal use only: extension place holder for Company.
  CompanyInfoEx?: IntuitAnyType;
}